export const NAV_LINKS = [
  { label: "Grades", href: "#grades" },
  { label: "Applications", href: "#applications" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const COMPANY = {
  name: "Rich Global RMC",
  founder: "Chetan Shirke",
  founderTitle: "Founder & Director",
  tagline: "Ready-Mix Concrete. Delivered across Mumbai. 24×7.",
  phone: "+91 80976 24546",
  phoneRaw: "+918097624546",
  phone2: "+91 81694 89331",
  phone2Raw: "+918169489331",
  email: "chetanshirke@httpsrich-global-rmc.com",
  email2: "Richglobalrmc@gmail.com",
  address: "Ghodbunder Road, Mira Bhayandar, Thane, Mumbai, Maharashtra",
  hours: "Open 24 Hours · 7 Days a Week",
};

export const GRADES = [
  { code: "M10", strength: "10 MPa", use: "PCC, leveling, non-structural fill", tag: "Plain" },
  { code: "M15", strength: "15 MPa", use: "Flooring, pavements, foundations", tag: "Plain" },
  { code: "M20", strength: "20 MPa", use: "Slabs, beams, residential RCC", tag: "Standard" },
  { code: "M25", strength: "25 MPa", use: "Columns, footings, commercial RCC", tag: "Standard" },
  { code: "M30", strength: "30 MPa", use: "High-rise, bridges, water tanks", tag: "Design Mix" },
  { code: "M35", strength: "35 MPa", use: "Heavy infrastructure, piling", tag: "Design Mix" },
  { code: "M40", strength: "40 MPa", use: "Highways, runways, precast", tag: "Design Mix" },
  { code: "M45", strength: "45 MPa", use: "Heavy piling, marine works", tag: "Design Mix" },
  { code: "M50", strength: "50 MPa", use: "High-rise cores, long-span bridges", tag: "High Strength" },
  { code: "M55", strength: "55 MPa", use: "Heavy structural, transfer slabs", tag: "High Strength" },
  { code: "M60", strength: "60 MPa", use: "Columns, precast, high-load slabs", tag: "High Strength" },
  { code: "M70", strength: "70 MPa", use: "Special structures, high-performance", tag: "High Performance" },
];

export const SERVICES = [
  "Design Mix Concrete",
  "Concrete Pumping",
  "Site Delivery",
  "Boom Placers",
  "Batching On Demand",
];

export const CEMENT_BRANDS = [
  "ACC",
  "Ambuja",
  "UltraTech",
  "Vicat",
  "JK Laxmi",
  "Hathi",
];

export const APPLICATIONS = [
  {
    title: "Highways & Roads",
    n: "01",
    img: "https://images.pexels.com/photos/14186205/pexels-photo-14186205.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: "High-strength mixes engineered for load, abrasion and speed of pour on arterial roads and expressways.",
  },
  {
    title: "High-Rise Buildings",
    n: "02",
    img: "https://images.pexels.com/photos/18162494/pexels-photo-18162494.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: "Pumpable design mixes delivered to height with consistent workability for towers and podiums.",
  },
  {
    title: "Railways & Infra",
    n: "03",
    img: "https://images.pexels.com/photos/9716233/pexels-photo-9716233.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: "Durable, low-permeability concrete for viaducts, sleepers, tunnels and heavy civil structures.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "One city. Total coverage.",
    body: "We batch and deliver exclusively across Mumbai — from Mira Bhayandar to the docks. Local focus means faster trucks, fresher pours and zero excuses.",
  },
  {
    n: "02",
    title: "The plant never sleeps.",
    body: "24 hours. 7 days. Night pours, monsoon schedules, emergency slabs — our batching plant runs when your project does.",
  },
  {
    n: "03",
    title: "Mix by design, not by luck.",
    body: "Every cubic metre is proportioned to spec. M10 to M70, laboratory-verified, slump-tested and traceable from plant to pour.",
  },
];
